import { ANALYSIS_SERVICE_CONFIG } from '@/composables/saju-insight/useAnalysisServices';

/**
 * analysisTypeId → 라우트 경로 매핑
 *
 * - 사주 분석 계열 (3,4,8,9,10,41): /analysis/{primarySajuId}?menu={overviewPath}
 * - 낭만궁합 (38), 낭만작명 (47): /saju-service에서 사주 선택 후 상세분석으로 이동
 * - 택일 (13,14): /selection
 * - 일진 (35,36): /fortune
 */

/** 사주 선택을 포함한 서비스별 진입 경로 */
const FIXED_ROUTE_MAP = {
  13: '/selection',
  14: '/selection',
  35: '/fortune',
  36: '/fortune',
  38: '/saju-service?menu=/overviewNangmanHarmony',
  47: '/saju-service?menu=/overviewNangmanNaming',
};

/**
 * analysisTypeId로 이동할 라우트 경로를 반환
 *
 * @param {number} analysisTypeId - 분석 타입 ID
 * @param {object} options
 * @param {string|number|null} options.primarySajuId - 대표사주 guestUserId (사주 분석 계열에 필요)
 * @returns {{ path: string, label: string } | null} 라우트 경로와 서비스 이름, 매핑 없으면 null
 */
export const getRouteByAnalysisTypeId = (analysisTypeId, { primarySajuId = null } = {}) => {
  // 1. 고정 경로 (택일, 일진, 궁합)
  if (FIXED_ROUTE_MAP[analysisTypeId]) {
    return {
      path: FIXED_ROUTE_MAP[analysisTypeId],
      label: getServiceLabel(analysisTypeId),
    };
  }

  // 2. 사주 분석 계열 (ANALYSIS_SERVICE_CONFIG 기반)
  const serviceEntry = Object.entries(ANALYSIS_SERVICE_CONFIG).find(
    ([, cfg]) => cfg.typeId === analysisTypeId,
  );

  if (serviceEntry) {
    const [, cfg] = serviceEntry;
    if (!primarySajuId) return null;
    return {
      path: `/analysis/${primarySajuId}?menu=${cfg.overviewPath}`,
      label: getServiceLabel(analysisTypeId),
    };
  }

  return null;
};

/** analysisTypeId → 서비스 이름(한글) */
const SERVICE_LABELS = {
  3: '성향분석',
  4: '용신분석',
  8: '사주풀이',
  9: '신년운세',
  10: '월운세',
  13: '맞춤택일',
  14: '맞춤택일',
  35: '낭만일진',
  36: '낭만일진',
  38: '낭만궁합',
  41: '용신라이트',
  47: '낭만작명',
};

/**
 * analysisTypeId로 서비스 이름 반환
 * @param {number} analysisTypeId
 * @returns {string}
 */
export const getServiceLabel = (analysisTypeId) => {
  return SERVICE_LABELS[analysisTypeId] || '분석 서비스';
};

/**
 * 상품의 detail 배열에서 첫 번째 analysisTypeId 추출
 * @param {object} product - 상품 객체 (product.detail 배열 포함)
 * @returns {number|null}
 */
export const getAnalysisTypeIdFromProduct = (product) => {
  return product?.detail?.[0]?.analysisTypeId || null;
};
